import React, { ReactNode, useReducer } from 'react';
import { AnswerTemplateProvider } from './answerTemplateContext/answerTemplateContext';

export function SocialProvider({ children }: { children: ReactNode }) {
  return <AnswerTemplateProvider>{children}</AnswerTemplateProvider>;
}
